import React, { Fragment } from 'react';

const SidebarOption = ({ 
    active, 
    toggle, 
    handleSlideMenu, 
    text, 
    link, 
    help_sidebarOption,
    danger
}) => {

    return (
        <Fragment>
            {/* If Toggle is enabled perform a smooth scroll */}
            {toggle ? (
                <div onClick={handleSlideMenu} style={{textDecoration:'none', paddingLeft: '20px'}}>
                    <div className={`sidebarOption ${active && 'sidebarOption--active'} ${help_sidebarOption && 'help_sidebarOption'}`} onClick={() => {
                        // Smooth scroll logic
                        const ref = document.querySelector(link);

                        ref?.scrollIntoView({
                            behavior: 'smooth'
                        })
                    }}>
                        {/* Text */}
                        <h2>{text}</h2>
                    </div>
                </div>
            ) : (
                <a href={link} onClick={toggle && handleSlideMenu} style={{textDecoration:'none'}}>
                    <div className={`sidebarOption ${active && 'sidebarOption--active'} ${help_sidebarOption && 'help_sidebarOption'}`}>
                        {/* Text */}
                        <h2 className={danger ? 'danger_text' : ''}>{text}</h2>
                    </div>
                </a>
            )}
        </Fragment>
    )
}

export default SidebarOption;